import {
  Link as ChakraLink,
  LinkProps as ChakraLinkProps,
  forwardRef,
} from '@chakra-ui/react';

// Re-export Chakra's LinkProps to maintain full polymorphic support
export type LinkProps = ChakraLinkProps;

// Use Chakra's forwardRef to preserve polymorphic behavior
export const Link = forwardRef<LinkProps, typeof ChakraLink>(
  ({ isExternal, rel, ...rest }, ref) => {
    // When isExternal is true, automatically add security attributes
    // https://elementor.com/blog/noopener-noreferrer/
    const securityRel = isExternal ? 'noopener noreferrer' : '';

    // Merge existing rel with security attributes
    const mergedRel = rel
      ? `${rel} ${securityRel}`.trim()
      : securityRel || undefined;

    return (
      <ChakraLink ref={ref} {...rest} isExternal={isExternal} rel={mergedRel} />
    );
  },
);

Link.displayName = 'Link';
